import React, { Component } from "react";
import { color } from "../common/constants";
import { renderImg } from "./icons/img";
import { getImgPath, handleImgError } from "./helper";

class LineInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focus: false,
      blur: false,
    };
    this.ref = React.createRef();
  }

  getBorderColor = () => {

    if (this.state.focus) {
      return color.blue;
    }

    // if (this.state.blur) {
    if (
      this.props.validation === "email" && this.props.value &&
      !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.props.value)
    ) {

      return "red";
    }
    if (
      this.props.validation === "gstno" && this.props.value &&
      !/^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([Zz]){1}([a-zA-Z0-9]){1}?$/.test(
        this.props.value
      )
    ) {
      return "red";
    }
    if (
      this.props.validation === "mobile" && this.props.value &&
      (this.props.value < 6000000000 || (this.props.value + "").length !== 10)
    ) {
      return "red";
    }
    // if (
    //   this.props.validation === "password" && (this.props.value + "").length === 0
    // ) {
    //   return "red";
    // }
    // if (!this.props.value || this.props.value === "") {
    //   return "#01aef0";
    // }
    // }
    return "#ddd";
  };

  getErrorMsg = () => {
    if (
      this.props.validation === "email" && this.props.value &&
      !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.props.value) && this.state.blur
    ) {
      return <span style={{ position: 'absolute', left: '0', bottom: '-25px', color: 'red' }}>{this.props.errorMsg}</span>
    }
    if (
      this.props.validation === "mobile" && this.props.value &&
      (this.props.value < 6000000000 || (this.props.value + "").length !== 10) && this.state.blur
    ) {
      return <span style={{ position: 'absolute', left: '0', bottom: '-25px', color: 'red' }}>{this.props.errorMsg}</span>
    }
  }

  getlabelColor = () => {

    if (this.state.focus) {
      return color.blue;
    }

    // if (this.state.blur) {
    if (
      this.props.validation === "email" && this.props.value &&
      !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.props.value)
    ) {
      return "red";
    }
    if (
      this.props.validation === "gstno" && this.props.value &&
      !/^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([Zz]){1}([a-zA-Z0-9]){1}?$/.test(
        this.props.value
      )
    ) {
      return "red";
    }
    if (
      this.props.validation === "mobile" && this.props.value &&
      (this.props.value < 6000000000 || (this.props.value + "").length !== 10)
    ) {
      return "red";
    }

    if (
      this.props.validation === "imobile" && this.props.value &&
      (this.props.value < 600000 || (this.props.value + "").length < 6)
    ) {
      return "red";
    }
    // if (
    //   this.props.validation === "password" && (this.props.value + "").length === 0
    // ) {
    //   return "red";
    // }
    // if (!this.props.value || this.props.value === "") {
    //   return "#01aef0";
    // }
    // }
    return "#000";
  };

  handleBlur = () => {
    this.setState({ focus: false, blur: true })
    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur();
    }
  }

  handleRef = () => {
    let type = this.ref.current.type;
    if (type === 'password') {
      this.ref.current.type = 'text';
    } else {
      this.ref.current.type = 'password'
    }
  }

  handleKeyPress = (event) => {
    if (this.state.focus) {
      if (event.key === "Enter") {
        let active = document.activeElement;
        // Find the next focusable element
        let allElements = document.querySelectorAll('[tabindex]');
        let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 1);

        if(this.props.inpType === 'onward_idCardno' || this.props.inpType === 'return_idCardno'){
            target =  Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 2);
        }
        // Focus the next element if it exists
        if (target) {
          target.focus();
        }
      }
    }
  };

  render() {
    return (
      <div style={{ ...this.props.style, position: "relative" }}>
        <input
          type="password"
          name="password"
          style={{
            position: "absolute",
            opacity: 0,
            height: "0px",
            width: "0px",
            margin: "0px",
            padding: "0px",
          }}
        />
        {
          this.props.rsicon === true &&
          <span className={`${this.state.focus || this.props.value.toString().length > 0 ? 'active' : ''}`}>₹</span>
        }
        <input
          type={this.props.type}
          value={this.props.value}
          onFocus={() => this.setState({ focus: true, blur: false })}
          onBlur={() => this.handleBlur()}
          onChange={this.props.handleChange}
          onClick={this.props.onClick}
          tabIndex={this.props.tab}
          name={this.props.name}
          maxLength={this.props.max}
          autoFocus={this.props.tab === 1 || this.props.autoFocus || this.props.tab === 1001}
          // autoComplete="none"
          autoComplete="off"
          readOnly={this.props.readOnly}
          disabled={this.props.disabled}
          pattern={this.props.pattern}
          style={{
            background: "transparent",

            border:
              !this.state.focus && !this.state.blur
                ? "1px solid"
                : "2px solid ",
            outline: 0,
            width: "100%",
            padding: this.props.isImg ? "20px 0 5px 40px" : "18px 10px",
            borderColor: this.getBorderColor(),
            transition: "0.3s ease",
            borderRadius: this.props.InputRadius || "6px",
            height: this.props.InputHeight || "45px",
          }}
          className={`${this.state.focus || this.props.value && this.props.value.toString().length > 0 ? 'active' : ''}`}

          ref={this.ref}
          onKeyDown={this.handleKeyPress}
        />
        <label
          style={{
            position: "absolute",
            left: this.props.isImg ? "40px" : "7px",
            fontSize:
              this.state.focus || (this.props.value + "").length > 0
                ? "0.75em"
                : "inherit",
            bottom:
              this.state.focus || (this.props.value + "").length > 0
                ? "34px"
                : "15px",
            transition: "0.3s ease",
            pointerEvents: "none",
            color: this.state.focus ? color.blue : this.getlabelColor(),
            padding: "0 5px",
            background: "#fff",
          }}

          className={`${this.state.focus || this.props.value && this.props.value.toString().length > 0 ? 'active' : ''}`}
        >
          {this.props.placeholder}
        </label>
        {this.props.isImg ? (
          <img
            src={"/img/email.svg"}
            alt="email"
            style={{ position: "absolute", left: 0, bottom: 0 }}
          />
        ) : (
          ""
        )}

        {this.props.icon === 'inpDropIcon' &&
          <img
            src={getImgPath('/img/inpdropIcon.png')} onError={handleImgError}
            style={{ position: "absolute", right: '10px', bottom: '18px', pointerEvents: 'none' }}
          />
        }

        {this.props.imgType ? (
          <img src={getImgPath('/img/eyeclose.png')} onError={handleImgError} style={{ position: "absolute", right: '10px', bottom: '10px', cursor: 'pointer' }} onClick={this.handleRef} />
        ) : (
          ""
        )}
        {this.props.errorMsg && this.getErrorMsg()}
      </div>
    );
  }
}

export default LineInput;